import { useDebounce } from '@connected/ui/hooks/use-debounce';
import { Search, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type SearchInputProps = {
    route: any;
};

export default function SearchInput({ route }: SearchInputProps) {
    const { t } = useTranslation('general');
    const search = route.useSearch();
    const navigate = route.useNavigate();

    const [searchValue, setSearchValue] = useState<string>(() => search.search || '');

    const debouncedSearchValue = useDebounce(searchValue, 500);

    useEffect(() => {
        const newSearchParams = new URLSearchParams(location.search);
        if (debouncedSearchValue) {
            newSearchParams.set('search', debouncedSearchValue);
        }
        else {
            newSearchParams.delete('search');
        }

        navigate({
            to: location.pathname,
            search: Object.fromEntries(newSearchParams.entries()),
        });
    }, [debouncedSearchValue, navigate]);

    return (
        <div className="flex items-center border px-3 rounded-lg h-10 max-sm:w-full order-2 max-sm:order-3">
            <Search className="size-5 mr-2 text-input-hover group-focus-within:!text-input-secondary" />
            <input
                type="text"
                placeholder={t('general.search')}
                className="outline-none bg-inherit"
                value={searchValue}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setSearchValue(e.target.value);
                }}
            />
            {searchValue && (
                <div className="sm:ml-5">
                    <X
                        className="hover:cursor-pointer"
                        onClick={() => {
                            setSearchValue('');
                        }}
                    />
                </div>
            )}
        </div>
    );
}
